import { useCallback, useMemo, useState } from 'react';
/**
 * Checkbox selection over the flat list of Business Units an integration exposes for import
 * (Genesys "Business Units", Aspect "Routing Sets"). Selection is keyed by each unit's externalId.
 */
export var useBusinessUnitSelection = function (_a) {
    var businessUnits = _a.businessUnits, _b = _a.initialSelected, initialSelected = _b === void 0 ? null : _b;
    var _c = useState(new Set(initialSelected !== null && initialSelected !== void 0 ? initialSelected : [])), selected = _c[0], setSelected = _c[1];
    var allSelected = useMemo(function () { return businessUnits.length > 0 && businessUnits.every(function (bu) { return selected.has(bu.externalId); }); }, [businessUnits, selected]);
    var someSelected = useMemo(function () { return businessUnits.some(function (bu) { return selected.has(bu.externalId); }); }, [businessUnits, selected]);
    var toggleSelectAll = useCallback(function () {
        setSelected(function (prev) {
            var next = new Set(prev);
            var allChecked = businessUnits.length > 0 && businessUnits.every(function (bu) { return next.has(bu.externalId); });
            for (var _i = 0, businessUnits_1 = businessUnits; _i < businessUnits_1.length; _i++) {
                var bu = businessUnits_1[_i];
                if (allChecked)
                    next.delete(bu.externalId);
                else
                    next.add(bu.externalId);
            }
            return next;
        });
    }, [businessUnits]);
    var toggleRow = useCallback(function (externalId) {
        setSelected(function (prev) {
            var next = new Set(prev);
            if (next.has(externalId))
                next.delete(externalId);
            else
                next.add(externalId);
            return next;
        });
    }, []);
    return { selected: selected, setSelected: setSelected, allSelected: allSelected, someSelected: someSelected, toggleSelectAll: toggleSelectAll, toggleRow: toggleRow };
};
export default useBusinessUnitSelection;
